/*  src/screens/Dashboard/Overview/widgets/InputFunnelNumberWidget/InputFunnelNumberWidget.tsx  */
import React from 'react';
import {Box, Typography} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {useSelector} from 'react-redux';

import {RootState} from 'appredux/reducers';
import useDepotStats from '../useDepotStats';

import './InputFunnelNumberWidget.scss';

export default function InputFunnelNumberWidget(): React.ReactElement {
  const {start, end} = useSelector((s: RootState) => s.rdwDateFilter);
  const {loading, stats} = useDepotStats(start, end);

  // Ensure stats is always defined with default values
  const safeStats = stats || {
    quotesCount: 0,
    invoicesCount: 0,
    paidInvoicesCount: 0,
  };

  // Only show skeleton if loading AND no stats available
  if (loading && !stats) {
    return <Skeleton variant="rect" height={140} style={{borderRadius: 8}} />;
  }

  const rows = [
    {label: 'Quotes', value: safeStats.quotesCount ?? 0},
    {label: 'Orders', value: safeStats.invoicesCount ?? 0},
    {label: 'Paid orders', value: safeStats.paidInvoicesCount ?? 0},
  ];

  return (
    <Box className="funnel-widget numbers">
      <Typography className="widget-heading">
        INPUT FUNNEL – BY&nbsp;#&nbsp;ORDERS
      </Typography>

      {rows.map(({label, value}) => (
        <Box key={label} className="funnel-row">
          <Typography className="widget-value">{value}</Typography>
          <Typography className="row-label">{label}</Typography>
        </Box>
      ))}
    </Box>
  );
}
